import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
} from "react-native";

import { navigate } from "../../../../helpers/utils";

import ImageComponent from "../../common/ImageComponent";
import AppTheme from "../../AppTheme";
import ManaButton from "../../common/ManaButton";
import appPages from "../../../../appPages";
import GoalsHelper from "../GoalsHelper";

export default function GoalPresetsList(props) {
  const {
    controller,
    isFromCard = false,
    buttonText = "Or Create a Custom Daily, Weekly, or Monthly Goal",
    showGoals = true,
    onGoalCreated = () => {},
  } = props;
  const [goals, setGoals] = useState([]);

  // ------------------------------------- METHODS -------------------------------------
  useEffect(() => {
    setGoals(controller.state.goal_presets || []);
  }, [controller.state?.goal_presets]);

  const saveGoal = (g) => {
    const goal = GoalsHelper.getGoalModel({ model: g });

    GoalsHelper.saveGoal(
      controller,
      { ...goal, target_id: g.element.id },
      () => {
        if (isFromCard) {
          controller.navigation?.jumpTo(appPages.resolutionEditPage);
        }
        onGoalCreated();

        // Refresh goals presets
        controller.getApiData("goal_presets", {}, (goals) => {
          setGoals(goals || []);
        });
      },
    );
  };

  const goToCreateGoalPage = () => {
    navigate(controller, appPages.resolutionEditPage, "changePage", {
      goal: GoalsHelper.getGoalModel({}),
    });
  };

  return (
    <View>
      {props.children ? props.children : null}

      {showGoals ? (
        <View style={styles.goalsContainer}>
          {goals.map((g, index) => (
            <TouchableOpacity
              key={index}
              style={styles.goalTile}
              onPress={() => saveGoal(g)}
            >
              <ImageComponent style={styles.goalLogo} icon={g.element?.icon} />
              <Text style={styles.goalText} numberOfLines={2}>{g.name}</Text>
            </TouchableOpacity>
          ))}
        </View>
      ) : null}

      <ManaButton
        isMainButton
        text={buttonText}
        style={styles.button}
        styleText={styles.buttonText}
        onPress={goToCreateGoalPage}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  goalsContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  goalTile: {
    width: "33%",
    height: 78,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#F3F2F1",
    borderRadius: 4,
    borderWidth: 2,
    borderColor: "#FFF",
    paddingHorizontal: 5,
    paddingVertical: 6,
  },
  goalText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "500",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  goalLogo: {
    width: 30,
    height: 30,
    marginBottom: 5,
  },
  button: {
    height: 32,
    borderRadius: 6,
    marginTop: 8,
    width: "100%",
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
});
